import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.5 9.5H7.5C5.84315 9.5 4.5 10.8431 4.5 12.5V18.5C4.5 20.1569 5.84315 21.5 7.5 21.5H16.5C18.1569 21.5 19.5 20.1569 19.5 18.5V12.5C19.5 10.8431 18.1569 9.5 16.5 9.5H15.5M8.5 9.5V6.5C8.5 4.84315 9.84315 3.5 11.5 3.5H12.5C14.1569 3.5 15.5 4.84315 15.5 6.5V9.5M8.5 9.5H15.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
        <path
            clipRule="evenodd"
            d="M12.75 15.7993C13.1984 15.54 13.5 15.0552 13.5 14.5C13.5 13.6716 12.8284 13 12 13C11.1716 13 10.5 13.6716 10.5 14.5C10.5 15.0552 10.8016 15.54 11.25 15.7993V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V15.7993Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
